import { useTranslation } from 'react-i18next'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-[3px]',
}

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  const { t } = useTranslation()
  return (
    <div
      role="status"
      aria-label={t('common.loadingShort')}
      className={[
        'animate-spin rounded-full border-border border-t-accent',
        sizeClasses[size],
        className,
      ].join(' ')}
    />
  )
}
